import type { BulkUploadRepository } from "../repositories/BulkUploadRepository";

export class DownloadGlTemplateUseCase {
  constructor(private readonly repository: BulkUploadRepository) {}

  async execute(): Promise<void> {
    await this.repository.downloadGlTemplate();
  }
}
